import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import TrashCanIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/TrashCanIconPath";
import HandleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/HandleIconPath";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import styles from "./NewChecklistItem.module.css";

type ChecklistItemProps = {
  itemId: string;
  title: string;
  onDelete: () => void;
};

function NewChecklistItem({ itemId, title, onDelete }: ChecklistItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: itemId });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      {...attributes}
      className={styles["root"]}
    >
      <div
        {...listeners}
        className={styles["dragHandle"]}
        tabIndex={0}
        data-testid="checklist-drag-handle"
      >
        <FixaSSRIcon paths={HandleIconPath} />
      </div>
      <FixaText className={styles["text"]} textStyle="Body.M">
        {title}
      </FixaText>
      <FixaButton
        ssrIcon={TrashCanIconPath}
        iconOnly
        type="tertiary"
        size="xsmall"
        onClick={onDelete}
        data-testid="remove-checklist-item-button"
      />
    </div>
  );
}

export default NewChecklistItem;
